import { render } from "./TheCarTypes.vue?vue&type=template&id=42961dc4"
import script from "./TheCarTypes.vue?vue&type=script&lang=js"
export * from "./TheCarTypes.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__